// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__okcHj","col":"Table_col__2wKU_","fulfillmentStatus":"Table_fulfillmentStatus__1Ki6a","emailCol":"Table_emailCol__1suRm"};